import { Document } from './../index';

export class PresetDocument{
    public BatchFinished = false;
    public Reload = true;
    public Progress = '';
    public IsLoading: boolean;
    public PresetId: number;
    public Document: Document[] = [];
}
